import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ScreenSwapRoute } from 'src/components/shared/routes/ScreenSwapRoute';
import { actions } from 'src/features/user';
import { ConstructionMyDetail } from '../promotion/detail/ConstructionMyDetail';
import { ConstructionOtherDetail } from '../promotion/detail/ConstructionOtherDetail';
import { ResortDeepLinkPromotion } from './ResortDeepLinkPromotion';

export const ResortDeepLink: React.FC = () => {
  const dispatch = useDispatch();

  //ディープリンク使用時はホーム画面表示時のスプラッシュアニメーションを省略
  useEffect(() => {
    dispatch(actions.splashFinished());
  }, [dispatch]);

  return (
    <>
      <ScreenSwapRoute path={'/deep-link/promotion/:raid'}>
        <ResortDeepLinkPromotion />
      </ScreenSwapRoute>
      <ScreenSwapRoute path={'/deep-link/my-constructions/:id'}>
        <ConstructionMyDetail />
      </ScreenSwapRoute>
      <ScreenSwapRoute path={'/deep-link/constructions/:id'}>
        <ConstructionOtherDetail />
      </ScreenSwapRoute>
    </>
  );
};
